export function getServerUrl() {
  if (window.location.origin.includes("localhost")) {
    return "https://api.sarangauto.com/api";
  } else {
    return "https://api.sarangauto.com/api";
  }
  return window.location.origin;
}
